import script from "./SearchPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchPage.vue?vue&type=script&setup=true&lang=js"

import "./SearchPage.vue?vue&type=style&index=0&id=293be6a2&lang=scss"

const __exports__ = script;

export default __exports__